import ReplyOutlined from 'assets/icons/ReplyOutlined.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(ReplyOutlined, { displayName: 'ReplyOutlined' });
